module.exports = __webpack_public_path__ + "img/cities_anim.b4e8fa8f.gif";